module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "accordion__collection"
  }, [(_vm.collection) ? _c('h2', {
    staticClass: "sidebar__tag"
  }, [_c('a', {
    staticClass: "button-collapse-primary",
    class: {
      'button-collapse': _vm.isExpanded, 'active': _vm.isExpanded || _vm.isActive
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleExpand($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.collection.title))])]) : _vm._e(), (_vm.isExpanded) ? [(_vm.isLoading || _vm.isExpanding) ? _c('div', {
    key: "accordion__loading",
    staticClass: "accordion__loading"
  }, [_c('loading', {
    attrs: {
      "alt": true,
      "mini": true
    }
  })], 1) : _c('div', {
    key: "accordion__content",
    staticClass: "accordion__content"
  }, [_vm._t("default")], 2)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07aba33c","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/admin/components/sidebar/Collection.vue
// module id = oTIl
// module chunks = 0 1